/*globals $*/
'use strict'; let didScroll;

const getSvg = () => import("./external/functions/svg.js");
const getScrollTo = () => import("./external/functions/scroll_to.js");
const getGSAP = () => import("./external/functions/gsap.js");
const getReveal = () => import("./external/functions/reveal");
import { initStudioSlider } from "./external/slider/studio-slider";
import { initStudioMobileAlign } from "./external/studio/studio-mobile-align";
import { initProjectCard } from "./external/project/project-card";
import { initProjectParallax } from "./external/project/project-parallax";
import { initProjectNext } from "./external/project/project-next";
import { initHomeProjects } from "./external/home/home-projects";

//import AOS from 'aos';
//window.addEventListener('load', AOS.refresh);
//window.onload = function () { AOS.init(); };

document.addEventListener("DOMContentLoaded", function () {

   const loadModuleOnIntersection = (selector, importFunction, initFunction) => {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
         let moduleLoaded = false;
         const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting && !moduleLoaded) {
                  moduleLoaded = true;
                  importFunction().then(module => {
                     module[initFunction]();
                  }).catch(error => {
                     console.error(`Error loading module for ${selector}:`, error);
                  });
                  elements.forEach(element => observer.unobserve(element));
               }
            });
         }, { rootMargin: '0px 0px -200px 0px' });

         elements.forEach(element => {
            observer.observe(element);
         });
      }
   };

   if (document.querySelectorAll('.js-hscroll').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initScrollHorizontal();
      });
   }

   // LOAD SVG IF NEEDED
   if (document.querySelectorAll('.js-svg, .svg').length > 0) {
      getSvg().then(svgModule => {
         svgModule.prepareSvg();
      });
   }


   loadModuleOnIntersection(".js-reveal", getReveal, 'initReveal');

   // Initialize Studio Slider
   if (document.querySelectorAll('.js-studio-slider').length > 0) {
      initStudioSlider();
   }

   // Initialize Studio Mobile Alignment (Clientes - Destacados - Servicios)
   if (document.querySelectorAll('.s-studio').length > 0) {
      initStudioMobileAlign();
   }

   // Initialize Project Card (Floating Draggable Card)
   if (document.querySelectorAll('.js-project-card').length > 0) {
      initProjectCard();
   }

   // Initialize Project Parallax & Entrance
   if (document.querySelectorAll('.js-project-item').length > 0) {
      initProjectParallax();
   }

   // Initialize Next Project Transition
   if (document.querySelectorAll('.js-project-next, .js-project-curtain-enter').length > 0) {
      initProjectNext();
   }

   // Initialize Home Projects
   if (document.querySelectorAll('.js-home').length > 0) {
      initHomeProjects();
   }

});
